import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../ReduxTool/store/hooks";
import { useEffect, useRef, useState } from "react";
import {  ProposalCards, ProposalStep, TopStepper } from "./Proposal";
import { setModalHeaderFooter } from "../../../../ReduxTool/Slice/CommonReducers/CommonReducers";
import { IconAroowAlt, IconDashboard, IconheadsetMic, IconVerifiedUser } from "../../../../assests/icons/Icons";
import { IconSelRectangle } from "../../../../assests/icons/EPCIcon";
import Contract from "./contract";
// import Payment from "./Payment";
import PaymentSuccess from "./Paymentsuccess";
import { NewModal } from "../../../../Components/New/Modal/NewModal";
import Payment from "./Payment";
import Toast from "../../../../Components/ErrorBoundry/Toast";
import { setInformationModalById } from "../../../../ReduxTool/Slice/Map/MapReducer";

export interface ProposalStepConfig {
    step: ProposalStep;
    modalTitle: string;
    primaryBtn: string;
    secondaryBtn: string;
    onClick?: () => void;
}


export const PROPOSAL_STEP_CONFIG: Record<ProposalStep, ProposalStepConfig> = {
    1: { step: 1, modalTitle: "Review your proposal", primaryBtn: "Continue to Agreement", secondaryBtn: "Talk to Support" },
    2: { step: 2, modalTitle: "Review Agreement", primaryBtn: "Continue to Payment", secondaryBtn: "Talk to Support" },
    3: { step: 3, modalTitle: "Secure your solar installation", primaryBtn: "Pay & Start Installation", secondaryBtn: "Talk to Support",},
    4: { step: 4, modalTitle: "Payment Success", primaryBtn: "Go to Dashboard", secondaryBtn: "" },
};


interface ProposalModalProps { isOpen: boolean;stepApproval:number; setStepApproval:(val:number)=>void; onClose: () => void; onSupportOpen: () => void; onPay: () => void; isPaying?: boolean;}

const ProposalModal = ({ isOpen, onClose, onSupportOpen,stepApproval,setStepApproval, onPay, isPaying }: ProposalModalProps) => {
    const dispatch = useAppDispatch();
    const Navigate = useNavigate();
    // const [step, setStep] = useState<ProposalStep>(1);
    const step = stepApproval as ProposalStep;
    const [agreed, setAgreed] = useState(false);
    const [checkboxError, setCheckboxError] = useState(false);
    const [completedStep, setCompletedStep] = useState<number>(step);
    const [goingToDashboard, setGoingToDashboard] = useState(false);

    const checkboxRef = useRef<HTMLDivElement>(null);


    // Sync modal header/footer whenever step changes
    useEffect(() => {
        if (!isOpen) return;

        if (step > completedStep) {
            setCompletedStep(step);
        }

        const cfg = PROPOSAL_STEP_CONFIG[step];
        if(cfg) dispatch(setModalHeaderFooter({ title: cfg.modalTitle,   btnTxt: cfg.primaryBtn, secondaryBtnTxt: cfg.secondaryBtn, modalid:"proposalreview",isheader:true  }));
    }, [step, isOpen, completedStep]);
     const trackingDisableClick = () =>{ dispatch(setInformationModalById({id:"trackinginfomodal"}))}

    const handleClose = () => {
        if (step === 4) {
            trackingDisableClick()
        }
        setStepApproval(1);
        onClose();
    };

    const handlePrimary = async (btnLabel: string) => {
        if (goingToDashboard) return;
        if (btnLabel === "Talk to Support") {
            handleClose();
            onSupportOpen();
            return;
        }
        if (step === 2 && !agreed) {
            setCheckboxError(true)
            Toast({ messageText: "Please agree to the Terms & Conditions", messageType: "E", toastId: "agreement_toast" });
        //    checkboxRef?.current?.scrollIntoView({behavior:"smooth",block : "center"})
            return;
        }
        if (step === 3) {
            // Redirects to PayU; step 4 is shown after the payment is confirmed on return
            onPay();
            return;
        }
        if (step < 4) {
            setStepApproval(step + 1);
        } else {
            // "Go to Dashboard": the dashboard is lazy-loaded, so keep the button loading until its chunk is in
            setGoingToDashboard(true);
            try {
                await import("../../Dashboard/ProjectDashboard");
            } catch {
                // Navigate anyway; the route's Suspense retries the load
            }
            handleClose();
            Navigate("/Consumer");
        }
    };

    const handleStepClick = (s: ProposalStep) => {
        if(s <= completedStep) setStepApproval(s);
    };

    if (!isOpen) return null;

    // ── Per-step modal config ──────────────────────────────
    type ModalSize = "md" | "sm" | "small" | "lgx" | "lg" | "sm-x" | "smlg";

    interface StepModalProps { maxheight: string; modalSize: ModalSize; primaryBtnLeftIcon?: React.ReactNode; primaryBtnRightIcon?: React.ReactNode; secondaryBtnLeftIcon?: React.ReactNode;}

    const modalPropsByStep: Record<ProposalStep, StepModalProps> = {
        1: { maxheight: "70vh", modalSize: "smlg", secondaryBtnLeftIcon: <IconheadsetMic />, primaryBtnLeftIcon: <IconVerifiedUser />,},
        2: { maxheight: "70vh", modalSize: "smlg", secondaryBtnLeftIcon: <IconheadsetMic />, primaryBtnLeftIcon: <IconVerifiedUser />,},
        3: { maxheight: "70vh", modalSize: "smlg", secondaryBtnLeftIcon: <IconheadsetMic />, primaryBtnRightIcon: <IconAroowAlt />,},
        4: { maxheight: "80vh", modalSize: "smlg", primaryBtnLeftIcon: <IconDashboard />,},
    };

    const currentModalProps = modalPropsByStep[step];

    // ── Per-step content ───────────────────────────────────
    const renderStepContent = () => {
        switch (step) {
            case 1: return <ProposalCards />;
            case 2: return <Contract agreed={agreed} setAgreed={setAgreed} checkboxError={checkboxError} setCheckboxError={setCheckboxError}  checkboxRef={checkboxRef}  />;
            case 3: return <Payment />;
            case 4: return <PaymentSuccess />;
        }
    };

    const renderContent = () => (
        <div className="overflow-hidden min-w-[800px]">
            {step !== 4 && (<TopStepper currentStep={step} completedStep={completedStep} onStepClick={handleStepClick} />)}
            {renderStepContent()}
        </div>
    );

    return (
        <NewModal btnName="" scrollhide isAbleCLick isLoading={isPaying || goingToDashboard} maxheight={currentModalProps.maxheight} modalSize={currentModalProps.modalSize} onClick={handlePrimary} setIsCLose={handleClose} name={PROPOSAL_STEP_CONFIG[step].modalTitle}
         outlinelefticon={currentModalProps.secondaryBtnLeftIcon} primarylefticon={currentModalProps.primaryBtnLeftIcon} primaryrighticon={currentModalProps.primaryBtnRightIcon}>{renderContent()}</NewModal>
    );
};

export default ProposalModal;